'use client';

import * as React from 'react';
import Image from 'next/image';

import { APP_NAME } from '@workspace/common/app';
import { cn } from '@workspace/ui/lib/utils';

export type LogoElement = React.ComponentRef<'div'>;
export type LogoProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
  hideWordmark?: boolean;
};
export function Logo({
  hideSymbol,
  hideWordmark,
  className,
  ...other
}: LogoProps): React.JSX.Element {
  return (
    <div
      className={cn('flex items-center space-x-2', className)}
      {...other}
    >
      {!hideSymbol && (
        <div className="flex size-9 items-center justify-center p-1">
          <div className="flex size-7 items-center justify-center rounded-md border text-primary-foreground bg-white">
            <Image
              src="/ms-icon-150x150.png"
              alt={`${APP_NAME} logo`}
              width={16}
              height={16}
              className="size-6"
            />
          </div>
        </div>
      )}
      {!hideWordmark && <span className="font-bold">{APP_NAME}</span>}
    </div>
  );
}
